// Pembuat gambar tanaman garis untuk corak latar. Hasilnya selalu sama (tanpa acak).
// Koordinat dalam kotak 420 x 420. Pangkal tanaman ada di pojok kanan bawah.
const bez = (p, t) => {
  const u = 1 - t;
  return [
    u * u * u * p[0][0] + 3 * u * u * t * p[1][0] + 3 * u * t * t * p[2][0] + t * t * t * p[3][0],
    u * u * u * p[0][1] + 3 * u * u * t * p[1][1] + 3 * u * t * t * p[2][1] + t * t * t * p[3][1],
  ];
};
const heading = (p, t) => {
  const u = 1 - t;
  const dx = 3 * u * u * (p[1][0] - p[0][0]) + 6 * u * t * (p[2][0] - p[1][0]) + 3 * t * t * (p[3][0] - p[2][0]);
  const dy = 3 * u * u * (p[1][1] - p[0][1]) + 6 * u * t * (p[2][1] - p[1][1]) + 3 * t * t * (p[3][1] - p[2][1]);
  return (Math.atan2(dy, dx) * 180) / Math.PI;
};
const jit = (i) => {
  const x = Math.sin(i * 12.9898) * 43758.5453;
  return x - Math.floor(x) - 0.5;
};
const path = (p) => `M${p[0][0]} ${p[0][1]} C${p[1][0]} ${p[1][1]} ${p[2][0]} ${p[2][1]} ${p[3][0]} ${p[3][1]}`;

export const LEAF = "M0 0 C5 -9 17 -9 24 0 C17 9 5 9 0 0 Z";
export const VEIN = "M2 0 L21 0";

function addStem(out, p, o) {
  out.stems.push({ d: path(p), w: o.w });
  for (let i = 0; i < o.n; i++) {
    const k = o.n === 1 ? 0 : i / (o.n - 1);
    const t = o.from + (o.to - o.from) * k;
    const [x, y] = bez(p, t);
    const side = (i % 2 === 0 ? 1 : -1) * (o.flip || 1);
    out.leaves.push({
      x, y,
      ang: heading(p, t) + side * (46 + jit(i + o.seed) * 20),
      s: o.size * (1 - o.shrink * k),
    });
  }
  const [tx, ty] = bez(p, 1);
  out.leaves.push({ x: tx, y: ty, ang: heading(p, 1), s: o.size * 0.55 });
  out.dots.push({ x: tx + 5, y: ty - 3, r: 2.6 });
}

export function buildVine() {
  const out = { stems: [], leaves: [], dots: [] };
  const main = [[418, 418], [330, 392], [226, 330], [212, 176]];
  addStem(out, main, { n: 9, from: 0.1, to: 0.94, size: 1.25, shrink: 0.5, seed: 1, w: 1.4 });
  const a = bez(main, 0.34);
  addStem(out, [a, [a[0] - 40, a[1] - 34], [a[0] - 108, a[1] - 24], [a[0] - 150, a[1] + 8]],
    { n: 6, from: 0.18, to: 0.92, size: 1.0, shrink: 0.45, seed: 7, flip: -1, w: 1.2 });
  const b = bez(main, 0.62);
  addStem(out, [b, [b[0] + 26, b[1] - 20], [b[0] + 44, b[1] - 62], [b[0] + 34, b[1] - 104]],
    { n: 4, from: 0.25, to: 0.9, size: 0.85, shrink: 0.4, seed: 13, w: 1.1 });
  const c = bez(main, 0.18);
  addStem(out, [c, [c[0] - 18, c[1] + 4], [c[0] - 62, c[1] + 6], [c[0] - 92, c[1] + 22]],
    { n: 4, from: 0.3, to: 0.9, size: 0.8, shrink: 0.4, seed: 21, flip: -1, w: 1.0 });
  return out;
}
